import { render, staticRenderFns } from "./InventoryProcessingItem.vue?vue&type=template&id=28fd2f4e&"
import script from "./InventoryProcessingItem.vue?vue&type=script&lang=js&"
export * from "./InventoryProcessingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports